module.exports = __webpack_public_path__ + "img/202306_07.569f5334.jpg";